import React from 'react';
import { Alert, Box } from 'housecall-ui';

import { FormSkeleton } from '../components/FormSkeleton';

export const ErrorPage = () => {
  return (
    <>
      <Box mb={1}>
        <Alert severity="error">Something went wrong. Please try again.</Alert>
      </Box>
      <FormSkeleton />
    </>
  );
};
